import React, { useEffect } from "react";
import { Header, Footer, TopBar } from "../component";
import ScrollToTop from "react-scroll-up";
import { FiChevronUp } from "react-icons/fi";
import { useLocation } from "react-router-dom";
import { useThemeStore } from "../stores";
import { FaSun, FaMoon } from "react-icons/fa";

export const WebsiteTemplate = ({ children }) => {
	const { pathname } = useLocation();
	const { theme, setDarkMode, setLightMode } = useThemeStore();

	const activeTheme = theme === "lightmode" ? "active-light" : "active-dark";

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div className={activeTheme}>
			<TopBar />
			<Header />

			{children}
			<div className="theme-selector">
				<button
					className={`theme-btn ${theme === "lightmode" ? "active" : ""}`}
					onClick={() => setLightMode()}
				>
					<FaSun size={24} />
				</button>
				<button
					className={`theme-btn ${theme === "darkmode" ? "active" : ""}`}
					onClick={() => setDarkMode()}
				>
					<FaMoon size={24} />
				</button>
			</div>

			<div className="backto-top">
				<ScrollToTop showUnder={160}>
					<FiChevronUp />
				</ScrollToTop>
			</div>

			<Footer />
		</div>
	);
};

export default WebsiteTemplate;
